import { render, staticRenderFns } from "./CategoryUpdateDedicated.vue?vue&type=template&id=55e6704a"
import script from "./CategoryUpdateDedicated.vue?vue&type=script&lang=js"
export * from "./CategoryUpdateDedicated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports